const LangContactUs = {
	"contact._title": ["CONTACT US", "ទំនាក់ទំនង​មក​យើង​ខ្ញុំ"],

	"contact.subTitle._howCanWeHelp": [
		"Need some help on your Starbucks Rewards™ account?",
		"ត្រូវ​ការ​ជំនួយ​អំពី​​​គណនី​ Starbucks Rewards™​ របស់​លោក​អ្នក​?",
	],

	"contact.form._description": [
		"<p>We welcome all questions, comments and feedback - it helps us make your experience at Starbucks the best it can be.</p><p>Please select the topic below that best fits your comment or question, then e-mail us.</p>",
		"<p>យើង​ខ្ញុំ​ស្វាគមន៍​រាល់​ចម្ងល់ និង​មតិ​​​យោបល់​កែ​លម្អ​ទាំង​អស់​​​​របស់​លោក​អ្នក​ ។ វា​ជួយ​ឲ្យ​យើង​ខ្ញុំ​​ បន្ត​ផ្តល់​ជូន​លោក​អ្នក​​នូវ​​បទ​ពិសោធន៍​ដ៏​ល្អ​បំផុត​​ តាម​តែ​អាច​ធ្វើ​បាន​ ។</p><p>សូម​ជ្រើសរើស​យក​ប្រធាន​បទ​​ណា​មួយ​ខាង​ក្រោម ដែល​ស្រដៀង​​បំផុត​ទៅ​នឹង​មតិ​យោបល់​ ឬ​ចម្ងល់​របស់​លោក​អ្នក រួច​អ៊ីម៉ែល​មក​កាន់​យើង​ខ្ញុំ ។</p>",
	],

	"contact.form.label._privacyAgreement": [
		"Confirm that I am aware the personal data I submit to Starbucks will be used in accordance with the Starbucks Privacy Statement",
		"សូម​បញ្ជាក់​ ​ខ្ញុំ​ពិតជា​បាន​ដឹង​ថា​ព័ត៌មាន​ផ្ទាល់​ខ្លួន ​​ដែល​បាន​បំពេញ​ឲ្យ​ Starbucks នឹង​ត្រូវ​បាន​ប្រើប្រាស់​ស្រប​ទៅ​​តាម​ សេចក្តី​ថ្លែងការណ៍​សិទ្ធិ​ឯកជន​របស់​ Starbucks ។",
	],
	"contact.form.name._privacyAgreement": [
		"Privacy Agreement",
		"កិច្ច​ព្រម​ព្រៀង​​សិទ្ធិ​ឯកជន",
	],
	"contact.form._privacyAgreementRules": ["", ""],
}

export default LangContactUs



// WEBPACK FOOTER //
// ./src/resources/pages/LangContactUs.js